<div id="contact" class="contact-area ptb-100 bg-F7F5F4">
    <div class="container">
        <div class="section-title">
            <h4>Kapcsolat</h4>
            <h2>Üzenj <span>nekünk</span> !</h2>
            <p>Kérdés esetén vagy árajánlat kérés esetén vegye fel velünk a kapcsolatot.</p>
        </div>
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="contact-form">
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label>Név</label>
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text"
                                        #name="ngModel" class="form-control" id="name">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Kötelező mező</div>
                                        <div *ngIf="name.errors.minlength">Legalább {{
                                            name.errors.minlength.requiredLength }} karakter.</div>
                                        <div *ngIf="name.errors.maxlength">Name is maximum 50 character.</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label>Email</label>
                                    <input required ngModel name="email" type="text" #email="ngModel"
                                        class="form-control" id="email">
                                    <div class="alert alert-danger" *ngIf="email.touched && !email.valid">Email megadása kötelező.</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label>Tárgy</label>
                                    <input required ngModel name="subject" type="text" #subject="ngModel"
                                        class="form-control" id="subject">
                                    <div class="alert alert-danger" *ngIf="subject.touched && !subject.valid">Kötelező mező.</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label>Telefonszám</label>
                                    <input required ngModel name="number" type="text" #number="ngModel"
                                        class="form-control" id="number">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">Telefonszám megadása kötelező.</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label>Üzenet</label>
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30"
                                        rows="4" class="form-control"></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">Message is
                                        required.</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="btn btn-primary" [class.disabled]="!contactForm.valid">Küldés</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="contact-info">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <ul>
                                <li><i class="fas fa-map-marker-alt"></i> <span>Telephely:</span>16.kerület Margit utca
                                    114</li>
                                <li><i class="far fa-envelope"></i> <a
                                        href="mailto:info@nagyonfairkft.hu"><span>Email:</span>info@nagyonfairkft.hu</a></li>
                                <li><i class="fas fa-phone-alt"></i> <a href="tel:06303505566"><span>Telefonszám:</span>+36 30 350 5566</a></li>


                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>